import { Color } from "config/colors";
import { FontFamily, FontSize } from "config/font";
import styled from "styled-components";

export const CheckboxContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 16px;
`;

export const CheckboxTitle = styled.label<{ required?: boolean }>`
  font-size: ${FontSize.Standard};
  font-family: ${FontFamily.MontserratRegular}, Helvetica;
  font-weight: 500;
  color: ${Color.InputTextColor};
  margin-bottom: 4px;

  ${(props) =>
    props.required &&
    `
    &::after {
      content: '*';
      color: #ef4444;
      margin-left: 2px;
    }
  `}
`;

export const CheckboxOptionContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
`;

export const HiddenCheckbox = styled.input`
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
`;

export const CustomCheckbox = styled.label<{
  disabled?: boolean;
  checked?: boolean;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border: 2px solid ${(props) => (props.checked ? "#3b82f6" : "#d1d5db")};
  border-radius: 3px;
  background-color: ${(props) => (props.checked ? "#3b82f6" : Color.White)};
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  transition: all 0.2s ease;

  ${(props) =>
    props.disabled &&
    `
    opacity: 0.5;
    border-color: #d1d5db;
    background-color: #f9fafb;
  `}

  &:hover:not([disabled]) {
    border-color: #3b82f6;
  }
`;

export const CheckMark = styled.div<{ checked?: boolean }>`
  font-size: ${FontSize.Small};
  font-weight: bold;
  color: ${Color.White};
  opacity: ${(props) => (props.checked ? 1 : 0)};
  transition: opacity 0.2s ease;
`;

export const CheckboxLabel = styled.label<{ disabled?: boolean }>`
  font-size: ${FontSize.Standard};
  font-family: ${FontFamily.MontserratRegular}, Helvetica;
  color: ${(props) => (props.disabled ? "#9ca3af" : "#374151")};
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  user-select: none;
`;
